import React, { useState } from "react";
import { createData } from "../../utility/managerApi";
import CancelIcon from "@mui/icons-material/Cancel";

function AddCustomer({ setIsLoading, setAddtab, fetchCustomers, currentPage }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    comment: "",
    preference: "",
  });

  const handleChange = async (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("formData");
    setLoading(true);
    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    const response = await createData("customers/store", formData);
    let errorCheck = response?.response?.data?.error;

    if (errorCheck) {
    } else {
      setLoading(false);
      fetchCustomers(currentPage);
      setLoading(false);
      setAddtab(false);
    }
  };
  return (
    <div className="bg-white p-6 rounded-md">
      <div className="flex justify-end">
        <CancelIcon onClick={() => setAddtab(false)} />
      </div>
      <h3 className="text-2xl font-medium text-center">Add New Customer</h3>
      <form
        onSubmit={handleSubmit}
        className="py-12  flex flex-col justify-center items-center gap-6 "
      >
        <div className="flex flex-col gap-6 ">
          <div className="flex flex-col">
            <label htmlFor="">Name</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Customer Name"
              type="text "
              name="name"
              // id="email"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="">Comment</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Comment"
              type="text "
              name="comment"
              // id="email"
              value={formData.comment}
              onChange={handleChange}
              // required
            />
          </div>
          <div className="flex flex-col">
            <label htmlFor="">Preference</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[400px]"
              placeholder="Preference"
              type="text"
              // id="email"
              name="preference"
              value={formData.preference}
              onChange={handleChange}
              // required
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-3 text-white rounded-lg w-full lg:w-[400px] bg-blue-500"
        >
          {loading ? "Submitting.." : "Submit"}
        </button>
      </form>
    </div>
  );
}

export default AddCustomer;
